module.exports = __webpack_public_path__ + "static/media/green-image-background.14403bca.jpg";